export const tableCols = [
  {
    field: 'CO1_NAME',
    header: 'Company',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'CU1_NAME',
    header: 'Customer',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'CONTRACT_BIN_ID',
    header: 'Bin ID',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 175,
    align: 'left',
  },
  {
    field: 'ITEM_ID',
    header: 'Item ID',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 175,
    align: 'left',
  },
  {
    field: 'CUSTOMER_PART_NO',
    header: 'Customer Part No',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 175,
    align: 'left',
  },
  {
    field: 'PL1_SHORT_CODE',
    header: 'Plant Short Code',
    visible: false,
    filter: false,
    export: { visible: true, checked: true },
    width: 0,
    align: 'left',
  },
  {
    field: 'PL1_NAME',
    header: 'Plant Name',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'RA1_SHIP_TO_ID',
    header: 'Rack ID',
    visible: false,
    filter: false,
    export: { visible: true, checked: true },
    width: 0,
    align: 'left',
  },
  {
    field: 'RA1_SHIP_TO_NAME',
    header: 'Rack Name',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'UPLOAD',
    header: 'Status',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'DATE',
    header: 'Date',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'QUANTITY',
    header: 'Qty',
    visible: true,
    filter: false,
    export: { visible: true, checked: true },
    width: 100,
    align: 'right',
  },
  {
    field: 'MD1_PRICE',
    header: 'Price',
    visible: true,
    filter: false,
    export: { visible: true, checked: true },
    width: 100,
    align: 'right',
  },
  {
    field: 'MD1_UM',
    header: 'UM',
    visible: true,
    filter: false,
    export: { visible: true, checked: true },
    width: 100,
    align: 'left',
  },
  {
    field: 'PO_NUMBER',
    header: 'PO Number',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'JOB_NUMBER',
    header: 'Job Number',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'ORDER_NUMBER',
    header: 'Order Number',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'TOTAL_PRICE',
    header: 'Ext. Val',
    visible: true,
    filter: false,
    export: { visible: true, checked: true },
    width: 125,
    align: 'right',
  },
  {
    field: 'SCANNED_BY',
    header: 'Scanned By',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'SD1_QUOTE',
    header: 'Quote',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 100,
    align: 'left',
  },
  // ,{
  //     field: 'MODIFIED_ON',
  //     header: 'Last Update',
  //     visible: true,
  //     filter: false,
  //     export: {visible: false, checked: false},
  //     width: 225,
  //     align: 'left'
  // }
];

export const newOrderTableCols = [
  {
    field: 'CO1_NAME',
    header: 'Company',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'CU1_NAME',
    header: 'Customer',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'CONTRACT_BIN_ID',
    header: 'Bin ID',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 175,
    align: 'left',
  },
  {
    field: 'ITEM_ID',
    header: 'Item ID',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 175,
    align: 'left',
  },
  {
    field: 'CUSTOMER_PART_NO',
    header: 'Customer Part No',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 175,
    align: 'left',
  },

  {
    field: 'PL1_NAME',
    header: 'Plant Name',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },

  {
    field: 'RA1_SHIP_TO_NAME',
    header: 'Rack Name',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'UPLOAD',
    header: 'Status',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'DATE',
    header: 'Date',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'QUANTITY',
    header: 'Qty',
    visible: true,
    filter: false,
    export: { visible: true, checked: true },
    width: 100,
    align: 'right',
  },
  {
    field: 'MD1_PRICE',
    header: 'Price',
    visible: true,
    filter: false,
    export: { visible: true, checked: true },
    width: 100,
    align: 'right',
  },
  {
    field: 'MD1_UM',
    header: 'UM',
    visible: true,
    filter: false,
    export: { visible: true, checked: true },
    width: 100,
    align: 'left',
  },
  {
    field: 'PO_NUMBER',
    header: 'PO Number',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'JOB_NUMBER',
    header: 'Job Number',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'ORDER_NUMBER',
    header: 'Order Number',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'TOTAL_PRICE',
    header: 'Ext. Val',
    visible: true,
    filter: false,
    export: { visible: true, checked: true },
    width: 125,
    align: 'right',
  },
  {
    field: 'SCANNED_BY',
    header: 'Scanned By',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'SD1_QUOTE',
    header: 'Quote',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 100,
    align: 'left',
  },
  {
    field: 'PL1_SHORT_CODE',
    header: 'Plant Short Code',
    visible: false,
    filter: false,
    export: { visible: true, checked: true },
    width: 0,
    align: 'left',
  },
  {
    field: 'RA1_SHIP_TO_ID',
    header: 'Rack ID',
    visible: false,
    filter: false,
    export: { visible: true, checked: true },
    width: 0,
    align: 'left',
  },
];

export const altOldTableCols = [
  {
    field: 'CO1_NAME',
    header: 'Company',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'CU1_NAME',
    header: 'Customer',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'CONTRACT_BIN_ID',
    header: 'Bin ID',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 175,
    align: 'left',
  },
  {
    field: 'ITEM_ID',
    header: 'Item ID',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 175,
    align: 'left',
  },
  {
    field: 'CUSTOMER_PART_NO',
    header: 'Customer Part No',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 175,
    align: 'left',
  },
  {
    field: 'PL1_SHORT_CODE',
    header: 'Plant Short Code',
    visible: false,
    filter: false,
    export: { visible: true, checked: true },
    width: 0,
    align: 'left',
  },
  {
    field: 'PL1_NAME',
    header: 'Plant Name',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'RA1_SHIP_TO_ID',
    header: 'Rack ID',
    visible: false,
    filter: false,
    export: { visible: true, checked: true },
    width: 0,
    align: 'left',
  },
  {
    field: 'RA1_SHIP_TO_NAME',
    header: 'Rack Name',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'UPLOAD',
    header: 'Status',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'DATE',
    header: 'Date',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'QUANTITY',
    header: 'Qty',
    visible: true,
    filter: false,
    export: { visible: true, checked: true },
    width: 100,
    align: 'right',
  },
 /* {
    field: "MD1_PRICE",
    header: "Price",
    visible: false,
    filter: false,
    export: { visible: false, checked: false },
    width: 100,
    align: "right",
  },*/
  {
    field: 'MD1_UM',
    header: 'UM',
    visible: true,
    filter: false,
    export: { visible: true, checked: true },
    width: 100,
    align: 'left',
  },
  {
    field: 'PO_NUMBER',
    header: 'PO Number',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'JOB_NUMBER',
    header: 'Job Number',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'ORDER_NUMBER',
    header: 'Order Number',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
 /* {
    field: "TOTAL_PRICE",
    header: "Ext. Val",
    visible: false,
    filter: false,
    export: { visible: false, checked: false },
    width: 125,
    align: "right",
  },*/
  {
    field: 'SCANNED_BY',
    header: 'Scanned By',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'SD1_QUOTE',
    header: 'Quote',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 100,
    align: 'left',
  },
  // ,{
  //     field: 'MODIFIED_ON',
  //     header: 'Last Update',
  //     visible: true,
  //     filter: false,
  //     export: {visible: false, checked: false},
  //     width: 225,
  //     align: 'left'
  // }
];

export const altTableCols = [
  {
    field: 'CO1_NAME',
    header: 'Company',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'CU1_NAME',
    header: 'Customer',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'CONTRACT_BIN_ID',
    header: 'Bin ID',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 175,
    align: 'left',
  },
  {
    field: 'ITEM_ID',
    header: 'Item ID',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 175,
    align: 'left',
  },
  {
    field: 'CUSTOMER_PART_NO',
    header: 'Customer Part No',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 175,
    align: 'left',
  },

  {
    field: 'PL1_NAME',
    header: 'Plant Name',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },

  {
    field: 'RA1_SHIP_TO_NAME',
    header: 'Rack Name',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'UPLOAD',
    header: 'Status',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'DATE',
    header: 'Date',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 125,
    align: 'left',
  },
  {
    field: 'QUANTITY',
    header: 'Qty',
    visible: true,
    filter: false,
    export: { visible: true, checked: true },
    width: 100,
    align: 'right',
  },
/*  {
    field: "MD1_PRICE",
    header: "Price",
    visible: false,
    filter: false,
    export: { visible: false, checked: false },
    width: 100,
    align: "right",
  },*/
  {
    field: 'MD1_UM',
    header: 'UM',
    visible: true,
    filter: false,
    export: { visible: true, checked: true },
    width: 100,
    align: 'left',
  },
  {
    field: 'PO_NUMBER',
    header: 'PO Number',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'JOB_NUMBER',
    header: 'Job Number',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'ORDER_NUMBER',
    header: 'Order Number',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
 /* {
    field: "TOTAL_PRICE",
    header: "Ext. Val",
    visible: false,
    filter: false,
    export: { visible: false, checked: false },
    width: 125,
    align: "right",
  },*/
  {
    field: 'SCANNED_BY',
    header: 'Scanned By',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 150,
    align: 'left',
  },
  {
    field: 'SD1_QUOTE',
    header: 'Quote',
    visible: true,
    filter: true,
    export: { visible: true, checked: true },
    width: 100,
    align: 'left',
  },
  {
    field: 'PL1_SHORT_CODE',
    header: 'Plant Short Code',
    visible: false,
    filter: false,
    export: { visible: true, checked: true },
    width: 0,
    align: 'left',
  },
  {
    field: 'RA1_SHIP_TO_ID',
    header: 'Rack ID',
    visible: false,
    filter: false,
    export: { visible: true, checked: true },
    width: 0,
    align: 'left',
  },
];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/scanned-data/scanned-data.cols.ts